export const getContentTagForDisplay = (contentType: string) => {
  // API response references:
  // catalog: "CodingChallenge", "CtfChallenge", "HandsOnLesson"
  // admin paths: "coding_challenge", "hacking_challenge", "breakfix"
  // lesson view: "code_challenge", "hacking_challenge", "lesson", "app_lab"

  switch (contentType) {
    case "breakfix":
    case "lesson":
      return "Break/Fix";
    case "code_challenge":
    case "coding_challenge":
    case "codingChallenge":
      return "Coding_Challenge";
    case "hacking_challenge":
    case "ctfChallenge":
    case "hackingChallenge":
      return "Ctf_Challenge";
    case "appLab":
    case "app_lab":
      return "AI_SKILLS_LAB";
    default:
      return contentType;
  }
};

// Human-readable display labels for all known lesson/content types.
// Keys follow the canonical set in badgeNames.ts plus common API variant spellings.
export const LESSON_TYPE_DISPLAY_LABELS: Record<string, string> = {
  // canonical keys (from badgeNames.ts)
  assessment: "Assessment",
  breakfix: "Break/Fix",
  codingChallenge: "Coding Challenge",
  ctfChallenge: "CTF Challenge",
  exercise: "Exercise",
  hackingChallenge: "Hacking Challenge",
  path: "Path",
  quiz: "Quiz",
  todo: "To-Do",
  video: "Video",
  // variant spellings from API responses
  lesson: "Break/Fix",
  code_challenge: "Coding Challenge",
  coding_challenge: "Coding Challenge",
  hacking_challenge: "Hacking Challenge",
  appLab: "AI Skills Lab",
  app_lab: "AI Skills Lab",
};
